type PlaceholderProps = {
  text?: string;
};

const Placeholder = ({ text }: PlaceholderProps) => {
  return <div style={{ color: '#aaa', fontSize: '14px' }}>{text}</div>;
};

export default Placeholder;